/**
 * Messages plugin.
 * @param {Object} options { plugin options - see defaults }
 *
 */
var messages = function(options) {

    var _defaults = {
        namespace: 'messages',
        defaultClasses: 'message',
        dataTimeout: '[data-timeout]',
        scrollWithHeader: false
    }

    var widget = this;

    widget.options =  $.extend({}, _defaults, options || {});

    widget._buildDOMContainer();

    // hide all messages with [data-timeout]
    if ($(widget.options.dataTimeout, '.messages').length > 0) {
        $(widget.options.dataTimeout, '.messages').each(function() {
            widget.destroyMessage($(this), $(this).data('timeout'));
        });
    }

    if (widget.options.scrollWithHeader) {
        widget._bindScrollEvents();
    }

};

/**
 * Build container for all generated messages.
 *
 */
messages.prototype._buildDOMContainer = function() {
    var widget = this;
    var $layout;
    var $container;

    if ($('.row.messages').length === 0) {
        $layout = $("<div class='row messages small-collapse'></div>");
        $container = $("<div class='large-12 columns'></div>");
    }
    else {
        $layout = $('.row.messages');
        $container = $layout.children();
    }
    $layout.append($container);

    if ($('#header').length !== 0) {
        $layout.insertAfter($('#header'));
    }
    else {
        $('body').prepend($layout);
    }

    widget.container = $container;
};

/**
 * Destroy specified messages element.
 * @param {jQuery object} messages
 * @param {Integer} timeout
 *
 */
messages.prototype.destroyMessage = function(messages, timeout) {
    var widget = this;

    if (timeout !== undefined && timeout !== 0 && timeout !== '') {
        setTimeout(function(){
            messages.trigger('close.zf.trigger');
        }, timeout);
    }
};

/**
 * Create new message element and append to container.
 * @param {String} classes
 * @param {String} content
 * @param {Integer} timeout
 *
 */
messages.prototype.showMessage = function(classes, content, timeout) {
    var widget = this;
    var $callout = $("<div class='"+ widget.options.defaultClasses + " " + classes + "' data-closable></div>");
    var $icon = $("<span class='message-icon'></span>");
    var $content = $("<div class='message-content'></div>");
    var $closeButton = $("<button class='close-button' aria-label='Dismiss message' type='button' data-close><span aria-hidden='true'>&times;</span></button>");

    if (content.length > 0) {
        $content.html(content);
    }

    $callout.append($icon);
    $callout.append($content);
    $callout.append($closeButton);
    widget.container.append($callout);

    widget.destroyMessage($callout, timeout);
};

/**
 * Bind window scroll event and scroll messages with the header.
 * Can only be used, if header position is set to fixed.
 *
 */
messages.prototype._bindScrollEvents = function() {
    var widget = this;
    var header = $('#header');
    var messageContainer = $('.row.messages');

    if (header.length !== 0) {
        messageContainer.css('top', header.height() + 'px');

        $(window)
            .off('scroll.' + widget.options.namespace)
            .on('scroll.' + widget.options.namespace, function() {
                var headerTop = header[0].getBoundingClientRect().top;
                var offset = header.height() + headerTop;
                if ((offset <= header.height()) && (offset > 0)) {
                    messageContainer.css('top', offset + 'px');
                }
                else {
                    messageContainer.css('top', '0px');
                }
            });
    }

};

export default messages;
